<template>
  <NotificationTemplate :notification="notification">
    <template #pic>
      <Avatar
        :src="notification.initiatorAvatarSrc || null"
        :gap="notification.getInitials()"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <span class="notification__update-item__initiator idea-comments__initiator">{{
          notification.initiatorFullName
        }}</span>
        added a comment to
        <a
          class="link is-large"
          target="_blank"
          :href="notification.itemHref"
        >
          {{ notification.displaySequenceNumber }}:
        </a>
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
        className="notification__update-item__description idea-comments__description"
      >
        <ReferencedText
          :resetStyle="true"
          :html="notification.comment"
        />
      </BaseSubHeading>

      <NotificationAttachmentFiles
        v-if="notification.attachments.length"
        :attachments="notification.attachments"
        :url="notification.itemHref"
        :attachmentsCount="notification.attachmentsCount"
      />
    </template>
  </NotificationTemplate>
</template>

<script setup lang="ts">
import Avatar from "@/components/Avatar/index.vue"
import NotificationAttachmentFiles from "@/components/Notification/components/NottificationAttacmentFiles.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import { ReferencedText } from "@/components/Reference"

import { NotificationComment } from "@/models/Notification"

defineProps<{
  notification: NotificationComment
}>()
</script>
